/**
 * @Description
 */
export default {
  path: '/system/closeReason',
  meta: {
    title: '关闭理由'
  }
};
